// @flow

import { action, computed, observable } from "mobx";

import Store from "app/stores/Store";
import AppearanceStore from "app/stores/AppearanceStore";
import GlobalSettingsStore from "app/stores/GlobalSettingsStore";

import UserService from "app/services/UserService";

import User from "app/models/User";

class UserStore extends Store {
    @observable user: ?User;

    @action
    setUser(user: ?User): void {
        this.user = user;
    }

    @action.bound
    updatePreference(preference: string, value: any) {
        UserService.updatePreference(preference, value).then(
            ({ data }) => {
                // $FlowFixMe
                this.user[preference] = value;
                this.setUser(this.user);
                AppearanceStore.notifySuccess(data.message);
            },
            ({ response }: any) => {
                AppearanceStore.notifyError(response.data.message);
            }
        );
    }

    @action.bound
    requestEarlyAccess(): Promise<*> {
        return UserService.requestEarlyAccess().then(
            ({ data }) => {
                AppearanceStore.notifySuccess(data.message);
            },
            ({ response }: any) => {
                AppearanceStore.notifyError(response.data.message);
            }
        );
    }

    @computed
    get hasEarlyAccess(): boolean {
        if (!GlobalSettingsStore.requireEarlyAccess) return true;

        return !!(this.user && this.user.early_access);
    }
}

export default new UserStore();



// WEBPACK FOOTER //
// ./src/app/stores/UserStore.js